var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10L3.27735 10.416C3.04759 10.5692 2.73715 10.5071 2.58397 10.2774L3 10ZM5.72265 7.58397C5.95241 7.4308 6.26285 7.49289 6.41603 7.72265C6.5692 7.95241 6.50711 8.26285 6.27735 8.41603L5.72265 7.58397ZM0.583975 7.27735C0.430799 7.04759 0.492886 6.73715 0.722651 6.58397C0.952414 6.4308 1.26285 6.49289 1.41603 6.72265L0.583975 7.27735ZM3.55279 14.2236C3.42929 13.9766 3.5294 13.6763 3.77639 13.5528C4.02338 13.4293 4.32372 13.5294 4.44721 13.7764L3.55279 14.2236ZM12 18.5C16.6944 18.5 20.5 14.6944 20.5 10H21.5C21.5 15.2467 17.2467 19.5 12 19.5V18.5ZM20.5 10C20.5 5.30558 16.6944 1.5 12 1.5V0.5C17.2467 0.5 21.5 4.75329 21.5 10H20.5ZM12 1.5C7.30558 1.5 3.5 5.30558 3.5 10H2.5C2.5 4.75329 6.75329 0.5 12 0.5V1.5ZM2.72265 9.58397L5.72265 7.58397L6.27735 8.41603L3.27735 10.416L2.72265 9.58397ZM2.58397 10.2774L0.583975 7.27735L1.41603 6.72265L3.41603 9.72265L2.58397 10.2774ZM12 19.5C9.91251 19.5 8.18865 18.9767 6.78515 18.041C5.38478 17.1074 4.33244 15.7829 3.55279 14.2236L4.44721 13.7764C5.16756 15.2171 6.11522 16.3926 7.33985 17.209C8.56135 18.0233 10.0875 18.5 12 18.5V19.5Z",
    fill: "rgba(0, 0, 0, 0.45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0955 6.72727V14H11.9947V7.82812H11.9521L10.212 8.96449V7.91335L12.0266 6.72727H13.0955Z",
    fill: "rgba(0, 0, 0, 0.45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondBackIcon);
export default __webpack_public_path__ + "static/media/secondBackIcon.5ebe7ad3fbbd7abe26b745d8f12d5344.svg";
export { ForwardRef as ReactComponent };